import React from "react";
import { Modal, Button } from "react-bootstrap";
import FormatDateTime from "../../functional/DateTimeFormatter";
import { history } from "../../../../helpers/history";

const PositiveIncidentModal = ({ onClose, positiveincident, showModal }) => {
  
  const createMarkup = (htmlString) => ({ __html: htmlString });
  return (
    <Modal
      show={showModal}
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-custom-modal-styling-title">
          Positive Incident Detail
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {positiveincident && (
          <div className="popup-border modalDetails">
            <div className="col-xs-12 m-b-5">
              <div className="row">
                <div className="col-xs-3 col-md-3">Incident Date:</div>
                <div className="col-xs-9 hideIfEmpty col-md-9">
                  <FormatDateTime
                    date={positiveincident.IncidentDateTime}
                    format="MM/DD/YYYY"
                  />
                </div>
              </div>
            </div>
            <div className="col-xs-12 m-b-5">
              <div className="row">
                <div className="col-xs-3 col-md-3">Incident Type:</div>
                <div className="col-xs-9 hideIfEmpty col-md-9">
                  <span>{positiveincident.IncidentType}</span>
                </div>
              </div>
            </div>
            <div className="col-xs-12 m-b-5">
              <div className="row">
                <div className="col-xs-3 col-md-3">Reported By:</div>
                <div className="col-xs-9 hideIfEmpty col-md-9">
                  <span>{positiveincident.ReportingStaff}</span>
                </div>
              </div>
            </div>
            <div className="col-xs-12 m-b-5">
              <div className="row">
                <div className="col-xs-3 col-md-3">Description:</div>
                <div
                  className="col-xs-9 hideIfEmpty col-md-9"
                  dangerouslySetInnerHTML={createMarkup(
                    positiveincident.IncidentDescription
                  )}
                ></div>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => history.push("/PositiveIncidents")}>
          Go <i className="fa fa-arrow-right"></i>
        </Button>
        <Button variant="secondary" onClick={onClose}>
          {" "}
          Close{" "}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default PositiveIncidentModal;
